import app from '~/scripts/app.js';
global['app'] = app

import '~/styles/main.less';

import dayjs from 'dayjs';
global['dayjs'] = dayjs
